import { TrophyOutlined } from "@ant-design/icons";

export default function Widget() {
  return (
    <div className="col-span-2 p-2  bg-white border shadow-sm">
      <div className="flex flex-col">
        <div className="flex items-center text-gray-500">

          <div className=""><TrophyOutlined /></div>
          <div className="mx-1">Total records</div>
        </div>
        <div className="font-bold">-</div>
      </div>
    </div>
  )
}
